import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import { formatDuration } from '../utils/rng';
import { playSound, isMuted, toggleMuted } from '../utils/audio';

// Opened by the gem under the view: save the party partway through a run,
// start a fresh run, or go back to the launch screen.
class GameMenu extends Component {
  state = { name: (this.props.context.savedParty || {}).name || '', saved: false, muted: isMuted() };

  toggleSound = () => {
    const muted = toggleMuted();
    this.setState({ muted });
    if (!muted) playSound('click');
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  // The menu is mounted for the whole session, so the party in play may have
  // been picked long after it was built. Offer that party's name each time the
  // menu opens, so saving updates them rather than making a second record.
  componentDidUpdate(previous) {
    const { gameMenuOpen, savedParty } = this.props.context;
    if (gameMenuOpen && !previous.context.gameMenuOpen) {
      this.setState({ name: (savedParty || {}).name || '', saved: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = (e) => {
    if (e.key === 'Escape' && this.props.context.gameMenuOpen) this.props.context.closeGameMenu();
  }

  // Saving under the name of the party in play writes over their old record
  updating() {
    const { savedParty } = this.props.context;
    return !!savedParty && savedParty.name.toLowerCase() === this.state.name.trim().toLowerCase();
  }

  save = () => {
    const name = this.state.name.trim();
    if (!name) return;
    if (this.props.context.saveParty(name)) this.setState({ saved: true });
  }

  render() {
    const { gameMenuOpen, run, closeGameMenu, restartGame, returnToMenu } = this.props.context;
    if (!gameMenuOpen) return null;

    return (
      <div id="gameMenu">
        <div className="menu-panel">
          <h1>The Party Rests</h1>
          {run && (
            <p className="menu-tagline">
              Level {run.level} of {run.levels} · {formatDuration(Date.now() - run.startedAt)} · seed {run.seed}
            </p>
          )}

          <label className="menu-row">
            <span>Save as</span>
            <input
              value={this.state.name}
              maxLength={24}
              placeholder="Party name"
              onChange={(e) => this.setState({ name: e.target.value, saved: false })}
              onKeyDown={(e) => { if (e.key === 'Enter') this.save(); }}
            />
            <button className={classNames('menu-button', 'small', { disabled: !this.state.name.trim() })} onClick={this.save}>
              {this.state.saved ? 'SAVED' : this.updating() ? 'UPDATE PARTY' : 'SAVE PARTY'}
            </button>
          </label>
          <p className="menu-hint">
            Keeps the characters as they are now. The dungeon itself is not saved: a saved party
            starts a fresh run.
          </p>

          <div className="menu-row">
            <span>Sound</span>
            <button
              className={classNames('menu-button', 'small', { chosen: !this.state.muted })}
              onClick={this.toggleSound}
            >
              {this.state.muted ? 'OFF' : 'ON'}
            </button>
          </div>

          <button className="menu-button start" onClick={() => { playSound('click'); closeGameMenu(); }}>
            RESUME (ESC)
          </button>

          <div className="menu-row menu-choices">
            <button className="menu-button" onClick={() => { playSound('click'); restartGame(); }}>NEW RUN</button>
            <button className="menu-button" onClick={() => { playSound('click'); returnToMenu(); }}>LAUNCH SCREEN</button>
          </div>
        </div>
      </div>
    );
  }
}

export default withContext(GameMenu);
